import { render, staticRenderFns } from "./TiptapToolbarStylesMenu.vue?vue&type=template&id=68d24b28&scoped=true"
import script from "./TiptapToolbarStylesMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TiptapToolbarStylesMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TiptapToolbarStylesMenu.vue?vue&type=style&index=0&id=68d24b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d24b28",
  null
  
)

export default component.exports